import OnOffSwitchContainer from "app/components/React/OnOffSwitchContainer/OnOffSwitchContainer";
import { StyledSwitchContainer } from "app/pages/industry-analysis/players/market-shares/StyledComponent";

type OnOffSwitchRegionalsContainerProps = {
    isRegionalsEnabled: boolean;
    toggleRegionals: (isSelected: boolean) => void;
    onOffSwitchLabel: string;
    isDisabled?: boolean;
};

const OnOffSwitchRegionalsContainer: React.FC<OnOffSwitchRegionalsContainerProps> = ({ isRegionalsEnabled, toggleRegionals, onOffSwitchLabel, isDisabled }) => {
    return (
        <StyledSwitchContainer isDisabled={isDisabled}>
            <OnOffSwitchContainer
                onToggle={toggleRegionals}
                isSelected={isRegionalsEnabled}
                isDisabled={isDisabled}
            />
            <div>{onOffSwitchLabel}</div>
        </StyledSwitchContainer>
    );
};

export default OnOffSwitchRegionalsContainer;
